import { useEffect } from 'react';

export default function SeoJsonLd() {
  useEffect(() => {
    const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://ahjunkremoval.com';

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#business`,
          name: 'A&H Junk Removal',
          description:
            'A&H Junk Removal is a father and son junk hauling business built on family values and loyalty. Professional residential and commercial junk removal, cleanout, and hauling services serving Riverside County, CA.',
          url: siteUrl,
          telephone: '+19514911655',
          email: 'ahjunkremoval2026@gmail.com',
          priceRange: '$$',
          currenciesAccepted: 'USD',
          paymentAccepted: 'Cash, Credit Card',
          areaServed: [
            'Riverside, CA',
            'Corona, CA',
            'Moreno Valley, CA',
            'Temecula, CA',
            'Murrieta, CA',
            'Menifee, CA',
            'Perris, CA',
            'Lake Elsinore, CA',
            'Hemet, CA',
          ],
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Riverside',
            addressRegion: 'CA',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 33.9806,
            longitude: -117.3755,
          },
          sameAs: [
            'https://www.facebook.com/marketplace/item/1188411236700848/',
            'https://instagram.com/a.hjunkremoval',
          ],
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '08:00',
              closes: '18:00',
            },
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Saturday'],
              opens: '08:00',
              closes: '16:00',
            },
          ],
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Junk Removal & Hauling Services',
            itemListElement: [
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Residential Hauling',
                  description:
                    'Clearing out your home, garage, or yard — furniture, appliances, yard waste, and everything in between.',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Commercial Cleanouts',
                  description:
                    'Office renovations, retail cleanouts, or warehouse clearing handled with full equipment and manpower.',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Home Staging Prep',
                  description:
                    'Pre-sale decluttering and staging preparation to showcase your property at its best.',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Construction Debris Removal',
                  description:
                    'Post-construction cleanup — drywall, lumber, concrete, and all building materials removed.',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Yard Waste Removal',
                  description:
                    'Branches, leaves, dirt, and landscaping debris hauled away leaving your property spotless.',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Same-Day Junk Removal',
                  description:
                    'Urgent same-day pickup for jobs that cannot wait — fast response across Riverside County.',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Eco-Friendly Disposal',
                  description:
                    'Items recycled, donated, or responsibly disposed of whenever possible.',
                },
              },
            ],
          },
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'A&H Junk Removal',
          description: 'Family-owned junk hauling and cleanout services in Riverside County, CA.',
          publisher: {
            '@id': `${siteUrl}/#business`,
          },
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: 'A&H Junk Removal | Family-Owned Hauling & Cleanout Services',
          description:
            'A&H Junk Removal is a father and son junk hauling business built on family values and loyalty. Professional residential and commercial junk removal services serving Riverside, Corona, Temecula, and surrounding cities.',
          isPartOf: {
            '@id': `${siteUrl}/#website`,
          },
          about: {
            '@id': `${siteUrl}/#business`,
          },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: siteUrl,
              },
            ],
          },
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'What areas do you serve for junk removal?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'We proudly serve Riverside County and surrounding cities including Riverside, Corona, Moreno Valley, Temecula, Murrieta, Menifee, Perris, Lake Elsinore, and Hemet.',
              },
            },
            {
              '@type': 'Question',
              name: 'Do you offer same-day junk removal service?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Yes! We offer same-day pickup for urgent junk removal jobs. Call us at (951) 491-1655 and we will be there fast.',
              },
            },
            {
              '@type': 'Question',
              name: 'How do I get a free quote from A&H Junk Removal?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'You can request a free quote by filling out our online form with photos of your junk, or by calling us directly at (951) 491-1655. We respond within 24 hours.',
              },
            },
            {
              '@type': 'Question',
              name: 'Do you offer a military discount?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Yes, A&H Junk Removal proudly supports our military and offers a special discount for active duty and veteran service members.',
              },
            },
          ],
        },
      ],
    };

    const existingScript = document.getElementById('schema-org-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-org-jsonld';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema, null, 2);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-org-jsonld');
      if (s) s.remove();
    };
  }, []);

  return null;
}
